import styles from './DeviceImage.module.css';

import deleteIcon from 'assets/svg/delete-01.svg';
import protocolIcon from 'assets/svg/protocol-01.svg';

import Tooltip from '../../../../ui/Tooltip';
import classNames from 'classnames';
import { address_server_short, PUBLIC_ASSETS } from '../../../../config';
import { SchemeModes } from '../../../../consts/scheme.consts';
import Icon from '../../../../helpers/components/Icon';

const DeviceImage = ({ item, schemeMode, handleDeleteDeviceModel, isProtocol = false }) => (
  <div className={styles.deviceItemContainer}>
    <Tooltip text={item.name} styleConfig={{ tooltip: styles.deviceTooltip }}>
      <div className={classNames(styles.containerImg)}>
        <div className={classNames(styles.containerImgSize, styles.deviceImageContainer)}>
          <img
            src={address_server_short + PUBLIC_ASSETS + item.image}
            className={classNames(styles.itemImg)}
            alt="N/A"
          />
          {schemeMode === SchemeModes.edit && !isProtocol && (
            <div className={styles.overlay} onClick={() => handleDeleteDeviceModel(item)}>
              <Icon src={deleteIcon} color={'var(--color-brand)'} width={'17px'} height={'17px'} />
            </div>
          )}
        </div>
        {isProtocol && (
          <div className={styles.imgIndicator}>
            <Icon
              src={protocolIcon}
              color={'var(--color-brand)'}
              className={styles.itemImg}
              width={'20px'}
              height={'20px'}
            />
          </div>
        )}
      </div>
    </Tooltip>
  </div>
);

export default DeviceImage;
